const map = {
	"./carousel2_controller.js": 2095,
	"./culture_controller.js": 9097,
	"./header_controller.js": 2854,
	"./home_controller.js": 800,
	"./home_ie11_controller.js": 7103,
	"./main_controller.js": 30,
	"./publications_controller.js": 7052,
	"./scroll_controller.js": 6578,
	"./scroll_ie11_controller.js": 9417,
	"./service_controller.js": 2410,
	"controllers/carousel2_controller.js": 2095,
	"controllers/culture_controller.js": 9097,
	"controllers/header_controller.js": 2854,
	"controllers/home_controller.js": 800,
	"controllers/home_ie11_controller.js": 7103,
	"controllers/main_controller.js": 30,
	"controllers/publications_controller.js": 7052,
	"controllers/scroll_controller.js": 6578,
	"controllers/scroll_ie11_controller.js": 9417,
	"controllers/service_controller.js": 2410
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8887;